import { useProfile } from '@/hooks/useProfile.hook';
import { Providers } from '@/types/providers.type';

export const useProviderAccount = (provider: Providers) => {
  const { profile } = useProfile();
  return { account: profile?.user?.accounts.find((account) => account.provider == provider) };
};
